import { useEffect } from 'react';

/**
 * Adds <meta name="robots" content="noindex, nofollow"> while `active` is
 * true, and removes it on unmount. For pages that are staged behind a launch
 * gate: reachable by URL for review, but kept out of search until go-live.
 */
export function useNoIndex(active: boolean) {
  useEffect(() => {
    if (!active) return;
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => {
      meta.remove();
    };
  }, [active]);
}
